import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../common/loader/Loader';
import backArrow from '../../images/icons-back-arrow.svg';
import styles from './PynwheelConnect.module.css';

type PynwheelConnectState = {
    pynwheelConnectUrl?: string | null;
    locationId?: string;
    locationName?: string;
};

const DEFAULT_PYNWHEEL_CONNECT_URL = 'https://pynwheelconnect.com/communities/3304/webpages';

const PynwheelConnect = () => {
    const navigate = useNavigate();
    const routeState = (useLocation().state || {}) as PynwheelConnectState;
    const iframeUrl = routeState.pynwheelConnectUrl || DEFAULT_PYNWHEEL_CONNECT_URL;
    const locationName = routeState.locationName || 'Pynwheel Connect';
    const [isLoading, setIsLoading] = useState(true);

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className="outletConainer" style={{ boxSizing: 'border-box', height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <div className={styles.pynwheelHeader}>
                <div className={styles.pynwheelBack}>
                    <span className={styles.backImage} onClick={handleBack}>
                        <img src={backArrow} alt="Back" />
                    </span>
                    <span className={styles.pynwheelTitle}>{locationName}</span>
                </div>
            </div>


            <div className={styles.pynwheelContent} style={{ position: 'relative' }}>
                {isLoading && <Loader />}
                {iframeUrl ? (
                    <iframe
                        title="Pynwheel Connect"
                        src={iframeUrl}
                        style={{ width: '100%', height: '100%', border: 0, display: 'block', background: '#ffffff' }}
                        allow="fullscreen"
                        onLoad={() => setIsLoading(false)}
                    />
                ) : (
                    <div style={{ padding: 24, color: '#3f4246' }}>Pynwheel Connect URL is not configured for this property.</div>
                )}
            </div>
        </div>
    );
};

export default PynwheelConnect;


